
import loginHeader from 'base/login-header'
import { login,getCodeImg } from 'api/user'
import Spinner from 'vux/src/components/spinner/index.vue'

import mycommon from 'mixins/common'

export default {
mixins:[mycommon],
data(){
return {
form:{
systemType:"0",
username:'',
password:'',

identify:'1'
},
codeImgUrl:''
}
},

methods:{
onblur(){
window.scroll(0,0);
},
onSubmit(){
this._login();
return false;
},
_login(){
if(this.loginFlag){
return ;
}
this.loginFlag = true;

if (this.form.username.length <= 0) {this.$vux.toast.text('用户名不能为空','middle');return;}
if (!(/^1[3|4|5|6|7|8|9]\d{9}$/.test(this.form.username))) {this.$vux.toast.text('手机号格式不正确','middle');return;}
if (this.form.password.length <= 0) {this.$vux.toast.text('密码不能为空','middle');return;}

this.$vux.loading.show({text: '加载中'})
login(this.form).then(async (res)=>{
this.$vux.loading.hide()
if(res.success){
this.$store.dispatch("changeToken", res.content);
this.$store.dispatch("changeName", res.content.name);
this.$store.dispatch("changeSex", res.content.sex);
this.$store.dispatch("changeStaffId", res.content.staffCode);

if(this.$route.query.cbURL){

this.$router.push(this.$route.query.cbURL)
}else{










this.$router.push({ path: '/member/index/' + this.KHchannalId })
}

}else{
this.$vux.toast.text(res.message)
}
this.loginFlag = false;


}).catch(err=>{
this.getCodeImgUrl()
this.$vux.loading.hide()
this.$vux.alert.show({
title: '提示',
content: err.message
})
this.loginFlag = false;
})
},
goToRegister(){
this.$router.push("/register/"+ this.KHchannalId)
},
changeCodeImg(){
this.getCodeImgUrl()
},
getCodeImgUrl(){
getCodeImg().then((data) => {
this.codeImgUrl = 'data:image/jpg;base64,' + data.content.base64Img;

}).catch((error) => {
this.$vux.toast.text(error.message,'middle')
})
},
goToFastLogin(){
this.$router.push({path:"/fastLogin/"+ this.KHchannalId,query:this.$route.query})

},
goToResetPwd(){
this.$router.push('/resetPassword/'+ this.KHchannalId)
}
},
components: {
Spinner,
loginHeader
},
mounted(){


var user = sessionStorage.getItem('user');

if(user){

window.location.href = "/#/member/index/" + this.KHchannalId;
}else{

}


}
}



// WEBPACK FOOTER //
// ./src/views/login.vue